export default __webpack_public_path__ + "static/girl-benefits-afad3965f46c2f3dda18e41b08363aab.png";